import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-conferma',
  templateUrl: './conferma.component.html',
  styleUrls: ['./conferma.component.css']
})
export class ConfermaComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  idRichiesta: any;
    objdettaglio: any;

  constructor(private fb: FormBuilder, private dialog: MatDialog, public dialogRef: MatDialogRef<ConfermaComponent>,
    private router: Router, private srvUtilita: UtilitaService, private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.frmInserimento = this.fb.group({

      Note: [null]
    })

    if (this.data.idRichiesta) {}

    this.idRichiesta = this.data.idRichiesta;
    // localStorage.getItem('idRichiesta');

    this.getDettaglio();
  }

  getDettaglio() {
    this.srvUtilita.getObj('Utenti/GetRichiesta?idRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objdettaglio = res
      // console.log(res, 'res')
    })
  }

  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    console.log("btnSalva", objInserimento);
    const obj = {
      idRichiesta: this.idRichiesta,
      Note: objInserimento.Note
    }

    this.srvUtilita.postObj('Utenti/PostSalvaNotePagamento', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')

    this.router.navigate(['/dashboard/']);
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })


  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }


  }
